import script from "./AccueilWidgets.vue?vue&type=script&setup=true&lang=js"
export * from "./AccueilWidgets.vue?vue&type=script&setup=true&lang=js"

import "./AccueilWidgets.vue?vue&type=style&index=0&id=334ebc27&lang=scss&scoped=true"
import "./AccueilWidgets.vue?vue&type=style&index=1&id=334ebc27&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-334ebc27"]])

export default __exports__